import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <h1 className="text-xl font-bold text-gray-800">
              Leads Management
            </h1>
            <div className="hidden md:flex items-center ml-8 space-x-2">
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  `px-3 py-2 text-sm rounded-md ${
                    isActive ? 'bg-primary-100 text-primary-700 font-medium' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                  }`
                }
              >
                Dashboard
              </NavLink>
              <NavLink
                to="/profile"
                className={({ isActive }) =>
                  `px-3 py-2 text-sm rounded-md ${
                    isActive ? 'bg-primary-100 text-primary-700 font-medium' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                  }`
                }
              >
                Profile
              </NavLink>
              {user?.role === 'admin' && (
                <NavLink
                  to="/admin/user-switch"
                  className={({ isActive }) =>
                    `px-3 py-2 text-sm rounded-md ${
                      isActive ? 'bg-primary-100 text-primary-700 font-medium' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                    }`
                  }
                >
                  User Switch
                </NavLink>
              )}
              {user?.role === 'admin' && (
                <NavLink
                  to="/admin/session-logs"
                  className={({ isActive }) =>
                    `px-3 py-2 text-sm rounded-md ${
                      isActive ? 'bg-primary-100 text-primary-700 font-medium' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                    }`
                  }
                >
                  Session Logs
                </NavLink>
              )}
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              {user?.profilePhoto ? (
                <img
                  src={user.profilePhoto}
                  alt={user.name}
                  className="h-8 w-8 rounded-full"
                />
              ) : (
                <div className="h-8 w-8 rounded-full bg-primary-600 flex items-center justify-center text-white font-semibold">
                  {user?.name?.charAt(0)?.toUpperCase()}
                </div>
              )}
              <div className="hidden md:block">
                <p className="text-sm font-medium text-gray-700">{user?.name}</p>
                <p className="text-xs text-gray-500">{user?.email}</p>
              </div>
            </div>
            
            <button
              onClick={logout}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
      {user?.impersonation && (
        <div className="bg-amber-50 border-t border-amber-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between">
            <p className="text-sm text-amber-800">
              You are impersonating <span className="font-semibold">{user?.email}</span>. Exit to return to admin login.
            </p>
            <button
              onClick={logout}
              className="px-3 py-1 text-xs font-medium text-white bg-amber-600 rounded-md hover:bg-amber-700"
            >
              Exit impersonation
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
